import { inject, Pipe, PipeTransform } from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import { SanitizeService } from 'src/app/shared/sanitize.service';

@Pipe({ name: 'sanitizeHtml' })
export class SanitizeHtmlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(value: any): SafeHtml {
    if (value != null) {
      return this.sanitizer.bypassSecurityTrustHtml(SanitizeService.sanitizeHtml(value));
    }
    return '';
  }
}
